export default __webpack_public_path__ + "static/help_06_04-3-017af383cb5f24b7cd2f06a6f1cd8fd1.png";